/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Configuration for a chart axis
 * @export
 * @interface AxisConfigDto
 */
export interface AxisConfigDto {
    /**
     * Label for the axis
     * @type {string}
     * @memberof AxisConfigDto
     */
    label?: string;
    /**
     * Unit to display (e.g., "EUR", "%", "contracts")
     * @type {string}
     * @memberof AxisConfigDto
     */
    unit?: string;
    /**
     * Minimum value for the axis (optional)
     * @type {number}
     * @memberof AxisConfigDto
     */
    min?: number;
    /**
     * Maximum value for the axis (optional)
     * @type {number}
     * @memberof AxisConfigDto
     */
    max?: number;
}

/**
 * Check if a given object implements the AxisConfigDto interface.
 */
export function instanceOfAxisConfigDto(value: object): value is AxisConfigDto {
    return true;
}

export function AxisConfigDtoFromJSON(json: any): AxisConfigDto {
    return AxisConfigDtoFromJSONTyped(json, false);
}

export function AxisConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AxisConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
    };
}

export function AxisConfigDtoToJSON(json: any): AxisConfigDto {
    return AxisConfigDtoToJSONTyped(json, false);
}

export function AxisConfigDtoToJSONTyped(value?: AxisConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'unit': value['unit'],
        'min': value['min'],
        'max': value['max'],
    };
}

